'use strict';

var cssUnits = require('../../helpers/css-units.js');

const modalTokens = (theme) => ({
    modalBackdropBackgroundColor: theme.palette.black,
    modalBackdropOpacity: 0.5,
    modalBackdropZIndex: theme.zIndices.modal,
    modalBackgroundColor: theme.colors.body.background,
    modalTextColor: theme.colors.body.text,
    modalShadow: theme.shadows.default,
    modalZIndex: theme.zIndices.modal,
    modalRadius: theme.radiuses.l,
    modalPaddingY: theme.space.component.y.l,
    modalItemPaddingX: theme.space.component.x.m,
    modalFullWidthSpaceToSide: theme.space.component.x.m,
    modalLargeWidth: cssUnits.pxToRem(872),
    modalMobilePaddingY: theme.space.component.y.m,
    modalMobileWidth: '100%',
    modalMobileBottom: '0rem',
    modalTabletWidth: cssUnits.pxToRem(cssUnits.emToPx(theme.devices.tablet.min) - cssUnits.remToPx(theme.space.component.x.s)),
    modalTabletGutterY: '5rem',
    modalLaptopWidth: cssUnits.pxToRem(cssUnits.emToPx(theme.devices.tablet.min) - cssUnits.remToPx(theme.space.component.x.s)),
    modalLaptopGutterY: '10rem',
    modalDesktopWidth: cssUnits.pxToRem(cssUnits.emToPx(theme.devices.tablet.min) - cssUnits.remToPx(theme.space.component.x.s)),
    modalDesktopGutterY: '10rem',
});

exports.modalTokens = modalTokens;
//# sourceMappingURL=modal.js.map
